import { FormControl, MenuItem, Typography, Select } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { useSelector } from 'react-redux'

import { trackPriorities } from 'constants/twilio'
import { _isTeacher } from 'store/selectors/User'

import useVideoContext from '../../../../hooks/useVideoContext/useVideoContext'
import VideoTrack from '../../../VideoTrack/VideoTrack'
import { useVideoInputDevices } from '../deviceHooks/deviceHooks'

const useStyles = makeStyles({
    preview: {
        width: '150px',
        height: '150px',
        margin: '0.5em 0',
    },
})

export default function VideoInputList() {
    const classes = useStyles()
    const videoInputDevices = useVideoInputDevices()
    const {
        room: { localParticipant },
        localTracks,
        getLocalVideoTrack,
    } = useVideoContext()
    const localVideoTrack = localTracks.find(track => track.kind === 'video')
    const localVideoInputDeviceId =
        localVideoTrack &&
        localVideoTrack.mediaStreamTrack.getSettings().deviceId

    const isTeacher = useSelector(_isTeacher)

    function replaceTrack(newDeviceId) {
        localVideoTrack.stop()
        getLocalVideoTrack({
            name: `camera-${Date.now()}`,
            deviceId: { exact: newDeviceId },
        }).then(newTrack => {
            if (localVideoTrack) {
                const localTrackPublication =
                    localParticipant &&
                    localParticipant.unpublishTrack(localVideoTrack)
                // TODO: remove when SDK implements this event. See: https://issues.corp.twilio.com/browse/JSDK-2592
                localParticipant &&
                    localParticipant.emit(
                        'trackUnpublished',
                        localTrackPublication
                    )
            }

            localParticipant &&
                localParticipant.publishTrack(newTrack, {
                    priority: isTeacher
                        ? trackPriorities.STANDARD
                        : trackPriorities.LOW,
                })
        })
    }

    console.count('VideoInputList Component')

    return (
        <div>
            {videoInputDevices.length > 1 ? (
                <FormControl>
                    <Typography variant="h6">Video Input:</Typography>
                    <Select
                        onChange={e => replaceTrack(e.target.value)}
                        value={localVideoInputDeviceId || ''}
                    >
                        {videoInputDevices.map(device => (
                            <MenuItem
                                value={device.deviceId}
                                key={device.deviceId}
                            >
                                {device.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            ) : (
                <>
                    <Typography variant="h6">Video Input:</Typography>
                    <Typography>
                        {(localVideoTrack &&
                            localVideoTrack.mediaStreamTrack.label) ||
                            'No Local Video'}
                    </Typography>
                </>
            )}
            {localVideoTrack && (
                <div className={classes.preview}>
                    <VideoTrack
                        position={'static'}
                        isLocal
                        track={localVideoTrack}
                    />
                </div>
            )}
        </div>
    )
}
